<template>
  <div>
    <slot
      v-if="propriedades.column.type === 'personalizada'"
      name="celula-personalizada"
    >
      <span
        v-if="propriedades.column.showActive"
        :class="propriedades.column.editable && permissaoUpdate ? 'editable-column' : ''"
        @click="editarItemPorColuna(propriedades.column.editable, propriedades.row)"
      >
        {{ propriedades.formattedRow[propriedades.column.field] }}
        <span :class="['ativo-badge', {'badge badge-success':propriedades.row.ativo, 'badge badge-danger': !propriedades.row.ativo}]">
          {{ propriedades.row.ativo ? 'Ativo' : 'Inativo' }}
        </span>
        <span
          v-if="(propriedades.row.hasUsuarioInativoVinculado || propriedades.row.erroIntegracaoOmie || propriedades.row.semEmailNfBoletos)"
          :class="['ativo-badge', {'badge badge-info':(propriedades.row.hasUsuarioInativoVinculado || propriedades.row.erroIntegracaoOmie || propriedades.row.semEmailNfBoletos)}]"
        >
          Atenção
        </span>
        <slot
          name="etiquetas-personalizadas"
        />
      </span>
    </slot>
    <span
      v-else-if="propriedades.column.type === 'Boolean'"
      :class="propriedades.column.editable && permissaoUpdate ? 'editable-column' : ''"
      @click="editarItemPorColuna(propriedades.column.editable, propriedades.row)"
    >
      {{ propriedades.formattedRow[propriedades.column.field] ? 'Sim' : 'Não' }}
    </span>
    <span
      v-else-if="propriedades.column.type === 'LargeText'"
      :class="propriedades.column.editable && permissaoUpdate ? 'editable-column' : ''"
      style="white-space: nowrap;overflow: hidden;text-overflow: ellipsis;max-width: 600px;display: block;"
      @click="editarItemPorColuna(propriedades.column.editable, propriedades.row)"
    >
      <span>
        {{ propriedades.formattedRow[propriedades.column.field] }}
      </span>
    </span>
  </div>
</template>

<style scoped>
.ativo-badge{
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}
</style>

<script>
export default {
  props: {
    propriedades: {
      type: Object,
      default: null,
    },
    permissaoUpdate: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    editarItemPorColuna(editable, row) {
      this.$emit('editar-item-coluna', { editable, row })
    },
  },
}
</script>
